module.exports = function toArray (list) {
  return Array.prototype.slice.call(list, 0)
}



/*****************
 ** WEBPACK FOOTER
 ** ./~/gangway/src/toArray.js
 ** module id = 85
 ** module chunks = 0
 **/